import { Helmet } from 'react-helmet-async';
import { Moon, Sun } from 'lucide-react';
import { useStore } from '@/store';
import { Button } from '@/components/ui/button';
import { useStoreInfo } from '@/lib/store';

export function SettingsPage() {
  const { darkMode, toggleDarkMode } = useStore();
  const { storeInfo } = useStoreInfo();
  const pageTitle = `Settings${storeInfo?.site_name ? ` - ${storeInfo.site_name}` : ''}`;

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content="Manage your app preferences" />
      </Helmet>

      <div className="min-h-screen bg-gray-100 dark:bg-gray-900 py-8">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-8">Settings</h1>

          <div className="bg-white dark:bg-gray-800 rounded-lg shadow overflow-hidden">
            <div className="divide-y divide-gray-200 dark:divide-gray-700">
              {/* Theme Toggle */}
              <div className="p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <h2 className="text-lg font-medium text-gray-900 dark:text-white">Theme</h2>
                    <p className="text-sm text-gray-500 dark:text-gray-400">
                      Choose between light and dark mode
                    </p>
                  </div>
                  <Button
                    onClick={toggleDarkMode}
                    variant="outline"
                    className="flex items-center gap-2"
                  >
                    {darkMode ? (
                      <>
                        <Sun className="h-5 w-5" />
                        <span>Light Mode</span>
                      </>
                    ) : (
                      <>
                        <Moon className="h-5 w-5" />
                        <span>Dark Mode</span>
                      </>
                    )}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}